import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import Modal from '../Modal'
import bear from './assets/bear.png'
import close from './assets/close.png'
import ewm1 from './assets/ewm1.png'
import ewm2 from './assets/ewm2.png'
import success from './assets/success.png'

const _TEXT = {
  dl: {
    title: '注册成功',
    tips1: '我们的课程顾问老师会在24小时内联系您',
    tips2: ['', '扫码领取16节小知识课程', ''],
    tips3: '',
    tips4: '扫描二维码',
    tips5: '获取更多精彩内容',
    ewm: 'https://imgvip.meishubao.com/vip/mpc/images/icon_code_new.png'
  },
  hw: {
    title: '注册成功',
    tips1: '我们的课程顾问老师会在24小时内联系您',
    tips2: ['您可以扫码关注下方“', '美术宝Global', '”Facebook'],
    tips3: '如有其他疑问可直接咨询',
    tips4: '扫描二维码',
    tips5: '获取更多精彩内容',
    ewm: ewm2
  }
}

interface Props {
  onClose: () => void
  show: boolean
  area: string
}

export default ({ onClose, show, area }: Props) => {
  const tk = area === '+86' ? 'dl' : 'hw'
  return (
    <Modal show={show} footer="" header="" style={{ padding: 0, boxShadow: 'none', backgroundColor: 'transparent' }}>
      <Container>
        <div className={'content'}>
          <img alt="" className={'bear'} src={bear} />
          <div className={'main'}>
            <img alt="" className={'close anim_btn2'} onClick={onClose} src={close} />
            <div className={'title'}>
              <img alt="" className={'success'} src={success} />
              <span>{_TEXT[tk].title}</span>
            </div>
            <div className={'tips1'}>{_TEXT[tk].tips1}</div>
            <div className={'tips2'}>
              {_TEXT[tk].tips2[0]}
              <span>{_TEXT[tk].tips2[1]}</span>
              {_TEXT[tk].tips2[2]}
            </div>
            <div className={'tips3'}>{_TEXT[tk].tips3}</div>
            <img alt="" className={'ewm'} src={_TEXT[tk].ewm} />
            <div className={'tips4'}>{_TEXT[tk].tips4}</div>
            <div className={'tips5'}>{_TEXT[tk].tips5}</div>
          </div>
        </div>
      </Container>
    </Modal>
  )
}

const Container = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .bear {
    width: 205px;
    display: block;
    margin: 0 auto -36px auto;
    z-index: 1;
    position: relative;
  }
  .main {
    position: relative;
    width: 540px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    text-align: center;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 1;
    color: rgba(102, 102, 102, 1);
    box-shadow: 0px 0px 0px 4px rgba(255, 255, 255, 0.25);
    .close {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 24px;
      top: 24px;
      cursor: pointer;
    }
    .title {
      font-size: 32px;
      font-family: PingFang SC;
      color: #000;
      line-height: 1;
      margin-bottom: 20px;

      display: flex;
      justify-content: center;

      .success {
        position: relative;
        top: -3px;
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
    }
    .tips1 {
      font-size: 16px;
      margin-bottom: 36px;
    }
    .tips2 {
      font-size: 18px;
      margin-bottom: 20px;
      span {
        font-size: 24px;
        color: #ff3300;
      }
    }
    .tips3 {
      font-size: 16px;
      color: #888888;
      margin-bottom: 20px;
    }
    .ewm {
      width: 226px;
      margin: 0 auto 15px auto;
    }
    .tips4,
    .tips5 {
      color: #666666;
      font-size: 16px;
      margin-bottom: 5px;
    }
  }
`
